<template>

  <div id="app">
    <div id="all" @mousemove="handleMouseMove" @keypress="handleKeyPress">
      <div id="header">
         <div id="title_bar">
          <div id="title">michaelanuzis.com:{{ pwd }}</div>
          <div id="home_link">
                  <a href="/">{{ pwd }}</a>
          </div>
        </div>
      </div>

      <div id="content">
        <div>$ {{ priorCommand }} </div>

        <DirectoryTable :typedLive="typedLive" />

        <div id="command-prompt-container">
          $ <span> {{ commandInputText }}</span>
          
        </div>

      </div>
    
    </div>
    
  </div>
</template>

<script>
import DirectoryTable from './components/DirectoryTable.vue'

export default {
  name: 'App',
  components: {
    DirectoryTable
  },
  data() {
        return {
            priorCommand: 'ls -l',
            pwd: '/home',
            typedLive: 7880,
            commandInputText: 'ready...',
        }
    },
    methods: {
        handleKeyPress(e) {
            var ignoreKeys = ['Tab', 'Control', 'Alt']
            if (this.commandInputText == 'ready...') {
                this.commandInputText = ''
            }
            if (e.key == 'Enter') {
                this.priorCommand = this.commandInputText
                this.commandInputText = ''
            } else if (e.key == 'Backspace') {
                this.commandInputText = this.commandInputText.slice(0, -1)
            } else if (ignoreKeys.indexOf(e.key) > -1) {
                // do nothing
            } else {
                this.commandInputText += e.key
            }
            this.typedLive += 1 + Math.floor(Math.random() * 200)
        },

    },
    // ref: https://stackoverflow.com/a/48419445/1377763
    mounted() {

        let self = this; 
    
        window.addEventListener('keyup', function(event) {
            self.handleKeyPress(event)
        });
    }




}
</script>

<style>
body, td, p, textarea, input, form, h1, h2, h3, .quote {
    font-family: Verdana, Arial, Helvetica, sans-serif; 
}

body {
    background-color: #000;
	background-image: url('assets/l2.gif');
	margin: 0px;
    padding: 0px;
    /*font-size: 13px;*/
    color: #0e3;
    font-weight: bold;
}

a {
	color: #f90;
}

a:active {
	color: #f93;
}

a:visited {
	color: #fc0;
}

#all {
	position: relative;
	padding-left: 10px;
	padding-right: 38px;
}

#header {
        width: 100%;
        position: relative;
        padding-top: 74px;
        margin-bottom: 20px;
}

#title_bar {
        width: auto;
        height: 30px;
        
        margin-right: 100px;
	font-family: "Courier New", Courier, mono;
	border: 1px solid #0e3;
	background-image: url('assets/l2.gif');
}

#title {
	margin-left: 15px;
	margin-top: 3px;
	float: left;
	font-size: 20px;
	font-weight: bold;
}

#home_link {
	margin-top: 6px;
	margin-right: 5px;
	float: right;
}

#corner {
        position: absolute;
        bottom: 0;
        right: 0;
	border: 1px solid #0e3;
	background-image: url('assets/l2.gif');
	width: 94px;
	height: 76px;
}

#corner_graphic {
	background: url('assets/l5.gif') no-repeat center center;
	width: 100%;
	height: 100%;
}

#content {
	margin-top: 10px;
        margin-left: 30px;
}

#side_nav {
	width: 235px;
        margin-left: 40px;
	border: 1px solid #0e3;
	background-image: url('assets/l2.gif');	
	position: relative;
	float: right;
	padding: 10px;
        display: block;
}

#side_nav a {
	
}

#side_nav li {
        margin: 0px;
}


div > ul {
        list-style-position: inside;
}

#copyright {
	float: right;
	font-family: "Courier New", Courier, mono;	
	font-size: 10px;
}

#footer {
	margin-top: 10px;
        width: 100%;
        height: 2em;
	text-align: right;
	line-height: 2.0em;
}

kbd, samp {
        display: block;
        margin: 1em;
        white-space: pre;
}

li ul {
        margin-top: 10px;
}

ol {
        list-style-position: inside;
}

ol li {
        font-weight: bold;
}

ol ol {
        margin: 20px 0;
        _margin-left: 30px;
        list-style-position: outside;
        list-style-type: lower-alpha;
}

ol ol li {
        font-weight: normal;
}

li blockquote {
        font-style: italic;
}

dt {
        font-weight: bold;
        margin-bottom: 1em;
}


caption {
        text-align: left;
        font-weight: bold;
        padding-bottom: 5px;
}

th {
        border-bottom: 3px double #0c3;
}

td {
        padding: 5px;
        border-bottom: 1px solid #0c3;
        vertical-align: top;
}

table {
    border: none;
    padding: 0;
}

th, td {
    border: none;
    padding: 0;
    margin: 0;
    font-weight: bold;
}

.clear {
        clear: both;
}

.command-prompt {
        background: transparent;
        color: #0c3;
        border: none;
        font-weight: bold;
        margin-left: 5px;
}

.d-none {
        display: none;
}


.pulsate {
        animation: pulsate 2s ease-out;
        animation-iteration-count: infinite;
        opacity: 1;
}
@keyframes pulsate {
        0% {
                opacity: 0.6;
        }
        50% {
                opacity: 1;
        }
        100% {
                opacity: 0.6;
        }
}
</style>
